<template>
  <div class="mt-5">
    <b-tabs pills vertical v-model="currentTab">
      <b-tab title="In" lazy>
        <SchoolFacialTeacherTable :device="device"></SchoolFacialTeacherTable>
      </b-tab>
      <b-tab :title="$t('DEVICEEMPLOYEE.LIST')" lazy>
        <SchoolFacialTeacherAvailableTable
          :device="device"
        ></SchoolFacialTeacherAvailableTable
      ></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SchoolFacialTeacherAvailableTable from "@/modules/school/components/device/facial/user/teacher/SchoolFacialTeacherAvailableTable";
import SchoolFacialTeacherTable from "@/modules/school/components/device/facial/user/teacher/SchoolFacialTeacherTable";
export default {
  name: "SchoolFacialDeviceTeacherModal",
  components: { SchoolFacialTeacherTable, SchoolFacialTeacherAvailableTable },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentTab: 0,
    };
  },
};
</script>

<style scoped></style>
